import { IconButton } from "@mui/material";
import RegeratePopoverForm from "./RegeratePopoverForm";
import { Autorenew, ContentCopyRounded, RedoOutlined, UndoOutlined } from "@mui/icons-material";
import { Toast } from "react-bootstrap";
import React, { useState, useRef, useReducer } from "react";
import { type } from "@testing-library/user-event/dist/type";

const GenAITemplateContentItem = ({ contentKey, contentValue, userInputData, sectionName }) => {

    // const [contentV, setContentV] = useState(contentValue);
    const [copied, setCopied] = useState(false);
    const [toastPosition, setToastPosition] = useState({ top: 0, left: 0 });

    const initialState = {
        contentV: contentValue,
        genAIcontentHistory: [contentValue],
        undoItemsAvailable: false,
        redoItemsAvailable: false
    };



    const toastRef = useRef();
    //console.log("key type", typeof (contentKey))
    //console.log("value type", typeof (contentV))

    const undo = (state) => {
        //console.log("Is genAIcontentHistory an array -> ",Array.isArray(state.genAIcontentHistory));

        const index = state?.genAIcontentHistory?.indexOf(state.contentV);
        const undoItemsAvailableTemp = (index !== -1 && !(index - 1 <= 0)) ? true : false;
        const contentVTemp = (index !== -1 && !(index - 1 < 0)) ? state?.genAIcontentHistory[index - 1] : state.contentV;
        return {
            undoItemsAvailableTemp,
            contentVTemp
        }
    }

    const redo = (state) => {
        const index = state?.genAIcontentHistory?.indexOf(state.contentV);
        const redoItemsAvailableTemp = (index !== -1 && (index + 1 < state?.genAIcontentHistory?.length - 1)) ? true : false;
        const contentVTemp2 = (index !== -1 && (index + 1 < state?.genAIcontentHistory?.length)) ? state?.genAIcontentHistory[index + 1] : state.contentV;
        return {
            redoItemsAvailableTemp,
            contentVTemp2
        }
    }

    function reducer(state, action) {
        switch (action.type) {
            case 'undo':
                const { undoItemsAvailableTemp, contentVTemp } = undo(state);
                return {
                    ...state,
                    contentV: contentVTemp,
                    undoItemsAvailable: undoItemsAvailableTemp,
                    redoItemsAvailable: state?.genAIcontentHistory?.length > 1 ? true : false
                };
            case 'redo':
                const { redoItemsAvailableTemp, contentVTemp2 } = redo(state);
                return {
                    ...state,
                    contentV: contentVTemp2,
                    redoItemsAvailable: redoItemsAvailableTemp,
                    undoItemsAvailable: state?.genAIcontentHistory?.length > 1 ? true : false
                };
            case 'update':
                return {
                    ...state,
                    contentV: action.payload,
                    genAIcontentHistory: [...state.genAIcontentHistory, action.payload],
                    undoItemsAvailable: state?.genAIcontentHistory?.length > 0 ? true : false,
                    redoItemsAvailable: state?.genAIcontentHistory?.length > 0 ? true : false
                };
            default:
                return state;
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);



    const copyToClipboard = (text, event) => {
        // Get the position of the clicked element
        const rect = event.target.getBoundingClientRect();
        setToastPosition({ top: rect.top + window.scrollY, left: rect.left + rect.width / 2 });

        navigator.clipboard.writeText(text).then(
            () => {
                setCopied(true);
                setTimeout(() => setCopied(false), 1000); // Auto-hide after 1 second
            },
            () => alert("Failed to copy text!")
        );
    };

    const autoResizeTextarea = (event) => {
        const target = event.target;
        target.style.height = "auto";
        target.style.height = `${target.scrollHeight}px`;
    };

    const formatText = (text) => {
        const words = text?.match(/[A-Z][a-z]+|[a-z]+|\d+/g);
        return words
            .map((word) =>
                /\d/.test(word) ? word : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
    };

    const [anchorEl, setAnchorEl] = useState(null);

    // Handle opening the popover
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Handle closing the popover
    const handleClose = () => {
        setAnchorEl(null);
    };

    const updateContent = (newValue) => {
        //setContentV(newValue);
        dispatch({ type: 'update', payload: newValue });
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div key={contentKey} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
            <label style={{ display: "block", fontWeight: "bold", flex: "1" }}>{contentKey && formatText(contentKey)}</label>
            <textarea
                value={state.contentV}
                readOnly
                onInput={autoResizeTextarea}
                style={{
                    flex: "4",
                    padding: "8px",
                    boxSizing: "border-box",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    marginRight: "10px",
                    resize: "none",
                    overflow: "hidden",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                }}
            />
            <div
                style={{
                    flex: "1",
                    border: "none",
                    borderRadius: "4px",
                    padding: "5px",
                    display: "flex",
                }}
            >
                
                    <IconButton color="primary" onClick={(event) => copyToClipboard(state.contentV, event)}>
                        <ContentCopyRounded />
                    </IconButton>
                    <IconButton color="primary" onClick={handleOpen}>
                        <Autorenew />
                    </IconButton>
                    <IconButton color="primary" onClick={() => dispatch({ type: 'undo' })} disabled={!state.undoItemsAvailable}>
                        <UndoOutlined />
                    </IconButton>
                    <IconButton color="primary" onClick={() => dispatch({ type: 'redo' })} disabled={!state.redoItemsAvailable}>
                        <RedoOutlined />
                    </IconButton>
                
                <RegeratePopoverForm anchorEl={anchorEl} open={open} onClose={handleClose} oldData={contentValue} updateContent={updateContent} userInputData={userInputData} sectionName={sectionName} contentKey={contentKey}/>
                {copied && (
                    <div
                        ref={toastRef}
                        style={{
                            position: "absolute",
                            top: toastPosition.top,
                            left: toastPosition.left,
                            transform: "translate(-50%, -50%)",
                            zIndex: 1050,
                        }}
                    >
                        <Toast show={copied} onClose={() => setCopied(false)} autohide delay={1000} style={{ width: "90px", textAlign: "right" }}>
                            <Toast.Body>Copied!</Toast.Body>
                        </Toast>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GenAITemplateContentItem;